<template>
  <div class="chat-container">

    <div class="messages" id="messages">
      <div>
        <div class="more" @click="getMsg">查看历史记录</div>
        <template v-for="item in messages">
          <message-line :data="item"></message-line>
        </template>
      </div>


    </div>
    <div class="send flex flex-mid">
      <div class="flex-1 mr-20">
        <el-input v-model="content" @keydown.native.13="send"></el-input>
      </div>
      <el-button type="primary" @click="send">发送</el-button>
    </div>

  </div>
</template>
<script>
  import MessageLine from "./MessageLine";
  export default{
    components: {MessageLine},
    name: 'chat',
    props: ['user'],
    data(){
      return {
        list: [],
        page: 1,
        next: true,
        tar: this.user || this.$store.state.LoginUser,
        content: ''
      }
    },
    computed: {
      messages(){
        return JSON.parse(JSON.stringify(this.list)).reverse()
      }
    },
    beforeMount(){
      this.getMsg()
    },
    methods: {
      send(){
          let isUser =  this.$store.state.LoginUser.type == 3;
        let adminRead = isUser? 0 : 1
        let userRead = isUser ? 1 : 0
        const params = {
          userId: (this.tar.userId || this.tar.id),
          content: this.content,
          name: this.$store.state.LoginUser.name,
          adminRead: adminRead,
          userRead: userRead,
          type: this.$store.state.LoginUser.type
        }
        this.$http$({method:'post',url:'/smartMeter/message/add',data:params},(data) => {

            this.list.unshift(data)
            this.content = ''
          this.goToBottom()

        })

      },
      goToBottom(){
          setTimeout(() => {
            var container = this.$el.querySelector("#messages")
            // console.log(container.scrollHeight)
            container.scrollTop = container.scrollHeight
          },200)

      },
      getMsg(){
        this.$http$({
          method: 'get',
          url: '/smartMeter/message/' + (this.tar.userId || this.tar.id) + '/' + this.$store.state.LoginUser.type,
          data: {page: this.page}
        }, (data) => {
          if (this.next) {
            this.list = this.list.concat(data.list)
            // console.log(this.list)
          }
          if (data.pageNum >= data.pages) {
            this.next = false
          }
          if(this.page == 1){
              this.goToBottom()
          }
          this.page++
        })
      }
    },
    watch: {
      user(val){
        this.list = []
        this.page = 1
        this.next = true
        this.content = ''
        this.tar= val

        this.getMsg()

      }
    }
  }
</script>
<style scoped="">
  .chat-container {
    width: 600px;
    height: 480px;
    border: 1px solid #c3c3c3;
  }

  .messages {
    height: 400px;
    width: 100%;
    overflow-y: auto;
    padding: 10px;
  }

  .send {
    height: 80px;
    border-top: 1px solid #c3c3c3;
    padding: 15px;
  }

  .more {
    line-height: 30px;
    font-size: 12px;
    text-align: center;
    color: #ccc;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Chat.vue